import { render, staticRenderFns } from "./project.vue?vue&type=template&id=82830b6e&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"
import style0 from "./project.vue?vue&type=style&index=0&id=82830b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82830b6e",
  null
  
)

export default component.exports